import React, { useContext, useEffect } from 'react';


import './Location.css'; // optional: for external CSS
import FetchRosterAllocationService from './FetchRosterAllocationService';
import FetchLocationsService from './FetchLocationsService';
import WebDropdownStyle from './WebDropdownStyle';

export default function Location(props) {
    const {
        token,
        showModal,
        companyAndLocations,
        setShowModal,
        selectedLocation,
        setSelectedLocation,
        setcompanyAndLocations,
        setBookedItems,
        bookedItems,
    } = props;



    useEffect(() => {
        console.log('called again');
        console.log('token', token);
        if (token === null || token === undefined) {
            console.error('Token is null or undefined');
            return;
        }
        if (token) {
            console.log('fetching data with token', token);
            FetchRosterAllocationService(token).then((response) => {
                if (response) {
                    //console.log('booked items', response);
                    setBookedItems(response);
                }
            });

            FetchLocationsService(token).then((response) => {
                if (response && response.length > 0) {
                    setcompanyAndLocations(response);

                    response.forEach((companyAndLocation) => {
                        companyAndLocation.locations.forEach((location) => {
                            if (location.defaultLocation === 'Y') {
                                console.log('default location', location);
                                setSelectedLocation({
                                    ...location,
                                    companyId: companyAndLocation.id,
                                });
                                filterBookedItemsByLocation(location);
                            }
                        });
                    });
                }
            });
        }
    }, [token]);

    const filterBookedItemsByLocation = (location) => {
        const modifiedItems = bookedItems.filter((item) => {
            return item.locationId === location.id;
        });

        setBookedItems(modifiedItems);
    };

    return (
        <div className="location-container">
            {showModal && (
                <div className="modal-overlay" onClick={() => setShowModal(false)}>
                    <div
                        className="modal-content"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div style={{ marginBottom: 20, textAlign: 'center' }}>
                            {/* Optional Modal Title */}
                        </div>
                        <WebDropdownStyle
                            filterBookedItemsByLocation={filterBookedItemsByLocation}
                            companyAndLocations={companyAndLocations}
                            setShowModal={setShowModal}
                            selectedLocation={selectedLocation}
                            setSelectedLocation={setSelectedLocation}
                        />
                    </div>
                </div>
            )}
        </div>
    );
}
